import React, { useRef, useState, useEffect } from "react";

import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";

//Unform e componentes
import { Form } from "@unform/web";
import UInput from "@/frontend/componentes/unform/UInput.jsx";

//Common
import { ID_AUTORIZACAO, UUID_GLOBAL } from "@/common/constantes.js";

//Util
import { ICONES_BOTAO } from "@/frontend/utils/icones.jsx";
import {
  fn_handleKeyDownEnterForm,
  fn_validarCamposObrigatorios,
} from "@/frontend/utils/form.jsx";

//API
import { api_finalizarConexaoID } from "@/frontend/services/api/api_system.jsx";

//Telas
import AutorizacaoRequerida from "../acesso/autorizacao/autorizacao_requerida.jsx";
import TAutorizacao_solicitacao from "../acesso/autorizacao/autorizacao_solicitacao.jsx";

function TEncerrar_conexao_bd({
  modalOpen,
  toggleModal,
  conexao,
  setKeyAtualizar,
}) {
  //### USE REF ###
  const formRef = useRef(null);

  //### USE STATE ###
  const [modalOpenAutorizacao, setModalOpenAutorizacao] = useState(false);

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //foco no primeiro campo
    const timer = setTimeout(() => {
      formRef?.current?.getFieldRef("motivo")?.current?.focus();
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  //### FUNCOES ###
  //Finaliza a conexão após autorizar
  async function confirmarAutorizacao(dadosAutorizacao) {
    const body = formRef.current.getData();

    const id = conexao?.pid || conexao?.sid;
    const serial = conexao?.serial;

    //Fializa a conexão
    const ret = await api_finalizarConexaoID(
      id,
      serial,
      conexao,
      body.motivo,
      dadosAutorizacao.id_autorizacao,
      dadosAutorizacao.id_usuario,
    );

    if (ret) {
      setKeyAtualizar((prev) => prev + 1);
      toggleModal();
    }
  }

  //Valida o formulário
  function validarFormulario(body) {
    //Valida os campos obrigatórios
    return fn_validarCamposObrigatorios(formRef, body);
  }

  //### EVENTOS ###
  //SUBMIT - Botão Confirmar
  function handleSubmit(body) {
    if (validarFormulario(body)) {
      setModalOpenAutorizacao(true);
    }
  }

  return (
    <Modal isOpen={modalOpen} backdrop="static">
      <Form
        ref={formRef}
        onSubmit={handleSubmit}
        onKeyDown={fn_handleKeyDownEnterForm}
      >
        <ModalHeader toggle={toggleModal} className="titulo-tela-modal">
          Encerrar conexão
        </ModalHeader>

        <ModalBody>
          <Row className="mb-2">
            <Col>
              <Label className="fw-bold danger me-2"> ATENÇÃO!</Label>
              <span>
                Tem certeza de que pode encerrar a conexão{" "}
                <strong>{conexao?.pid || conexao?.sid}</strong>?
              </span>
            </Col>
          </Row>

          <Row className="mb-2">
            <Col>
              <UInput
                id="lastField"
                name="motivo"
                label="Motivo*"
                maxLength={80}
              />
            </Col>
          </Row>

          <AutorizacaoRequerida />
        </ModalBody>

        <ModalFooter>
          <Button type="submit" name="btnSalvar" color="danger">
            {ICONES_BOTAO.CONFIRMAR} Confirmar
          </Button>
          <Button name="btnFechar" color="secondary" onClick={toggleModal}>
            {ICONES_BOTAO.FECHAR} Fechar
          </Button>
        </ModalFooter>
      </Form>

      {/* MODAL AUTORIZACAO */}
      {modalOpenAutorizacao && (
        <div>
          <TAutorizacao_solicitacao
            modalOpen={modalOpenAutorizacao}
            toggleModal={() => setModalOpenAutorizacao(!modalOpenAutorizacao)}
            id_tenant={UUID_GLOBAL}
            idAutorizacao={ID_AUTORIZACAO.SYS_ENCERRAR_CONEXAO_BANCO_DADOS}
            showMotivo={false}
            onSuccess={(dadosAutorizacao) =>
              confirmarAutorizacao(dadosAutorizacao)
            }
          />
        </div>
      )}
    </Modal>
  );
}

export default TEncerrar_conexao_bd;
